module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_1_mobile.03df7763.svg";